export const validatePaymentMethod = (
  value: string | undefined,
): string | true => {
  if (!value) {
    return 'Payment method is required.'
  }
  return true
}
